import React from "react";
import { hashHistory } from "../../browserHistory";

import TwitterIcon from "@material-ui/icons/Twitter";

import styled from "styled-components";
import { IconButton } from "@material-ui/core";

const HidePrint = styled.div`
  @media print {
    display: none;
  }
`;

const Footer = () => {
  return (
    <HidePrint>
      <div style={{ padding: 40, textAlign: "center" }}>
        <div style={{ display: "flex", fontSize: 14 }}>
          <div style={{ width: "50%" }}></div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginLeft: 10,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              hashHistory.push("/TermsOfUse");
            }}
          >
            Terms of Use
          </div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginLeft: 10,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              hashHistory.push("/Contact");
            }}
          >
            Contact Us
          </div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginLeft: 10,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              hashHistory.push("/AboutUs");
            }}
          >
            About Us
          </div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginLeft: 10,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              window.location.href= "https://roboppa.wixsite.com/website";
            }}
          >
            Blog
          </div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginLeft: 10,
              marginRight: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              window.open("http://assetallocationsoftware.org");
            }}
          >
            ALM Optimizer
          </div>
          <div
            style={{
              whiteSpace: "nowrap",
              marginLeft: 10,
              marginRight: 10,
            }}
            // onClick={() => {
            //   window.open("http://assetallocationsoftware.org");
            // }}
          >
            <div>
              <div style={{ fontWeight: "bold", marginBottom: 5 }}>
                Follow Us
              </div>
              <div style={{ textAlign: "left", cursor: "pointer" }}>
                <IconButton onClick={()=>{
                  window.open("https://twitter.com/Robo_PPA");
                }}>
                <TwitterIcon style={{color: '#1da1f2'}} />
                </IconButton>
              </div>
            </div>
          </div>
          <div style={{ width: "50%" }}>
            <div style={{ textAlign: "right", fontSize: 12 }}>
              © All Rights Reserved, 2020.
            </div>
          </div>
        </div>
      </div>
    </HidePrint>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/home/components/Footer.js